<script>import { createEventDispatcher, getContext } from "svelte";
import FieldContainer from "./helper/FieldContainer.svelte";
import Input from "./helper/Input.svelte";
import { createFieldContext } from "./helper/field.js";
export let name = void 0;
export let label;
export let callToInput = void 0;
export let assistText = void 0;
export let story = void 0;
export let value = void 0;
export let error = void 0;
export let disabled = false;
export const control = void 0;
export const locale = void 0;
export const context = void 0;
const contextKey = createFieldContext(name, value, error, disabled, value === void 0);
const ctx = getContext(contextKey);
const ctxValue = ctx.value;
$: {
  ctx.value.set(value);
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(value === void 0);
}
$:
  value = $ctxValue;
$:
  props = {
    label,
    callToInput,
    assistText,
    story,
    contextKey
  };
</script>

<FieldContainer {...props}>
	<svelte:fragment slot="input">
		<Input
			type="text"
			{contextKey}
			on:changed
			on:state
		/>
	</svelte:fragment>
</FieldContainer>
